var map = {
	"./bkg.png": "a315",
	"./black_left.png": "c278",
	"./gold_left.png": "8070",
	"./gold_right.png": "1edd",
	"./legal.png": "4236",
	"./tagline.png": "eb07",
	"./tagline/1.png": "0542",
	"./tagline/2.png": "c157",
	"./tagline/3.png": "f6ee",
	"./top_left.png": "e4c6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "16ba";